import React, { useEffect, useState } from "react";
import { ImageIcon } from "lucide-react";
import api, { mediaSrc } from "@/lib/api";

export default function Media() {
  const [media, setMedia] = useState([]);
  useEffect(() => { api.get("/media").then((r) => setMedia(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="media-page">
      <div className="eyebrow mb-1" style={{ letterSpacing: "0.16em" }}>Program Gallery</div>
      <h1 className="heading text-4xl mb-6">Media</h1>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {media.map((m) => (
          <div key={m.id} className="rounded-lg overflow-hidden bg-[var(--rsp-card)] border border-[var(--rsp-border)]" data-testid={`media-tile-${m.id}`}>
            {m.image_url ? (
              <img src={mediaSrc(m.image_url)} alt={m.title} className="w-full aspect-square object-cover" />
            ) : (
              <div className="w-full aspect-square flex items-center justify-center text-[var(--rsp-muted)] text-xs p-2 text-center">{m.title}</div>
            )}
            {m.caption && <div className="p-2 text-xs text-[var(--rsp-gray)] truncate">{m.caption}</div>}
          </div>
        ))}
      </div>
      {media.length === 0 && (
        <div className="rsp-card p-8 text-center text-[var(--rsp-muted)]"><ImageIcon className="mx-auto mb-2 opacity-50" /> No media yet.</div>
      )}
    </div>
  );
}
